import script from "./windowJAI.vue?vue&type=script&setup=true&lang=js"
export * from "./windowJAI.vue?vue&type=script&setup=true&lang=js"

import "./windowJAI.vue?vue&type=style&index=0&id=7507455c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7507455c"]])

export default __exports__